import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { http } from "../../../utils";
import { dataTableParamsBuilder } from "../../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../../utils/hooks";

function fetchIinquiryList(params) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL("/admin/inquiry", baseUrl);

  if (params.hospitalName) {
    endpointUrl.searchParams.append("hospitalName", params.hospitalName);
  }

  if (params.hospitalMemberEmail) {
    endpointUrl.searchParams.append(
      "hospitalMemberEmail",
      params.hospitalMemberEmail
    );
  }

  if (params.from) {
    endpointUrl.searchParams.append("from", params.from);
  }
  if (params.to) {
    endpointUrl.searchParams.append("to", params.to);
  }

  if (params.status) {
    endpointUrl.searchParams.append("status", params.status);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useInquiryList(params = {}) {
  return usePaginationQuery(
    [
      "inquiry",
      params.hospitalName,
      params.hospitalMemberEmail,
      params.from,
      params.to,
      params.status,
    ],
    (paginationState) => fetchIinquiryList({ ...params, ...paginationState })
  );
}
async function addInquiry(formData) {
  const data = await http(`/admin/inquiry`, {
    data: formData,
  });
  return data;
}

export function useAddInquiry() {
  const queryClient = useQueryClient();

  return useMutation(addInquiry, {
    onSuccess: () => {
      queryClient.refetchQueries(["-inquiry"]);
    },
  });
}

export function useUpdateInquiry() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation(
    async (data) => {
      const { id, ...payload } = data;
      const res = await http(`/admin/inquiry/${id}`, {
        method: "PUT",
        data: payload,
      });
      return res;
    },
    {
      onSuccess: async (res) => {
        if (res !== undefined) {
          await queryClient.invalidateQueries(["inquiry"]);
          setTimeout(() => {
            navigate("/bulletin-board/");
          }, 1500);
        }
      },
    }
  );
}

async function deleteInquiry(id) {
  const data = await http(`/admin/-inquiry/${id}`, {
    method: "DELETE",
  });

  return data;
}

export function useDeleteInquiry() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(deleteInquiry, {
    onSuccess: () => {
      queryClient.invalidateQueries(["-inquiry"]);
      setTimeout(() => {
        navigate("/bulletin-board");
      }, 1500);
    },
  });
}

export async function fetchInquiryDownload() {
  const { data } = await http(`/admin/inquiry-download`, {
    responseType: "blob",
  });

  return data;
}

export async function fetch1on1InquiryDownload(id) {
  const { data } = await http(`/admin/inquiries/${id}/attachs-download`, {
    responseType: "blob",
  });

  return data;
}

export function useInquiryDownload() {
  const { data, ...raResult } = useQuery(["inquiry-download"], () =>
    fetchInquiryDownload()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
